import Vue from "vue";
import { announcementsService } from "../services/announcement.service";

const ALL_KEY = "all";

function scopeKey({ entityType = null, entityId = null, onlyGlobal = false, searchQuery = null } = {}) {
  const base = entityType && entityId ? `${entityType}:${entityId}` : entityType || ALL_KEY;
  return base + (onlyGlobal ? "|global" : "") + (searchQuery ? `|q:${searchQuery}` : "");
}

const state = {
  counts: {},
};

const getters = {
  unreadCount: (state) => {
    return (scope = {}) => state.counts[scopeKey(scope)]?.unread || 0;
  },

  isCountLoaded: (state) => {
    return (scope = {}) => state.counts[scopeKey(scope)] !== undefined;
  },
};

const actions = {
  async fetchAnnouncements(_context, params = {}) {
    return await announcementsService.fetchAnnouncements(params);
  },

  async fetchAnnouncementCount({ commit }, { entityType = null, entityId = null, onlyGlobal = false, searchQuery = null } = {}) {
    try {
      const count = await announcementsService.fetchAnnouncementCount({ entityType, entityId, onlyGlobal, searchQuery });
      commit("setCount", { key: scopeKey({ entityType, entityId, onlyGlobal, searchQuery }), count });
      return count;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async markAllAnnouncementsAsRead({ commit }, { entityType = null, entityId = null, onlyGlobal = false, searchQuery = null } = {}) {
    try {
      await announcementsService.markAllAnnouncementsAsRead({ entityType, entityId, onlyGlobal, searchQuery });
      commit("setCount", { key: scopeKey({ entityType, entityId, onlyGlobal, searchQuery }), count: { unread: 0 } });
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async logAnnouncementView(_context, announcementIds) {
    return await announcementsService.logAnnouncementView(announcementIds);
  },

  async fetchAnnouncementById(_context, announcementId) {
    try {
      return await announcementsService.fetchAnnouncementById(announcementId);
    } catch (error) {
      return null;
    }
  },

  async createAnnouncement(_context, announcementData) {
    return await announcementsService.createAnnouncement(announcementData);
  },

  async createAnnouncements(_context, announcementData) {
    return await announcementsService.bulkCreateAnnouncements(announcementData);
  },

  async updateAnnouncement(_context, { announcementId, announcementData }) {
    return await announcementsService.updateAnnouncement(announcementId, announcementData);
  },

  async deleteAnnouncement(_context, announcementId) {
    return await announcementsService.deleteAnnouncement(announcementId);
  },
};

const mutations = {
  setCount(state, { key, count }) {
    Vue.set(state.counts, key, { ...state.counts[key], ...count });
  },

  clearAnnouncements(state) {
    state.counts = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
